import { isAnnotationLocked } from '../utils/annotationLockUtils';
import randomId from '../utils/randomId';

export const SET_ANNOTATION = 'SET_ANNOTATION';

const setAnnotation = (state, payload = {}) => {
  // dismissHistory is used to prevent considering this change in history (undo/redo).
  const {
    dismissHistory = false,
    replaceCurrent = false,
    ...newAnnotation
  } = payload;
  const annotationId = newAnnotation.id ?? randomId(newAnnotation.name);

  const existedAnnotation = state.annotations[annotationId];
  if (isAnnotationLocked(existedAnnotation)) {
    const patchKeys = Object.keys(newAnnotation).filter(
      (key) => key !== 'id',
    );
    const onlyVisibilityPatch =
      patchKeys.length > 0 &&
      patchKeys.every((key) => key === 'visible');
    if (!onlyVisibilityPatch) {
      return state;
    }
  }
  // If annotation not changed don't update it (strict !== so `visible: false` counts).
  const patchKeys = Object.keys(newAnnotation).filter((key) => key !== 'id');
  if (
    existedAnnotation &&
    patchKeys.length > 0 &&
    !patchKeys.some((key) => newAnnotation[key] !== existedAnnotation[key])
  ) {
    return state;
  }

  return {
    ...state,
    isDesignState: !dismissHistory, // not stored in state, used in reducer to consider in undo/redo stacks
    annotations: {
      ...state.annotations,
      [annotationId]: {
        ...(replaceCurrent ? {} : existedAnnotation),
        ...newAnnotation,
      },
    },
  };
};

export default setAnnotation;
